import FlexRow from '../../layout/flex/row.gjs';
import Super from '../../core/base.gjs';

export const ALIGN_ITEMS_DEFAULT = 'center';
export const GAP_DEFAULT = '8px';
export const JUSTIFY_CONTENT_DEFAULT = 'flex-end';

export default class SpdsModalFlyoutFooter extends Super {
  baseClass = 'spds-modal-flyout-footer';

  get gap() {
    return this.args.gap ?? GAP_DEFAULT;
  }

  get alignItems() {
    return this.args.alignItems ?? ALIGN_ITEMS_DEFAULT;
  }

  get justifyContent() {
    return this.args.justifyContent ?? JUSTIFY_CONTENT_DEFAULT;
  }

  <template>
    <FlexRow
      @alignItems={{this.alignItems}}
      @gap={{this.gap}}
      @justifyContent={{this.justifyContent}}
      @tag="footer"
      class={{this.classes}}
      data-test-spds-modal-flyout-footer
      ...attributes
    >
      {{yield}}
    </FlexRow>
  </template>
}
